import { type RoleDTO } from '@api/models';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private readonly http = inject(HttpClient);

  listReedgeRolesForCompany(): Observable<RoleDTO[]> {
    const uri = `${environment.api}/roles`;
    return this.http.get<RoleDTO[]>(uri);
  }

  getReedgeRole(id: string): Observable<RoleDTO> {
    const uri = `${environment.api}/roles/${id}`;
    return this.http.get<RoleDTO>(uri);
  }

  createReedgeRole(data): Observable<string> {
    const uri = `${environment.api}/roles`;
    return this.http.post<string>(uri, data);
  }

  updateReedgeRole(id: string, data): Observable<void> {
    const uri = `${environment.api}/roles/${id}`;
    return this.http.put<void>(uri, data);
  }

  deleteReedgeRole(id: string): Observable<void> {
    const uri = `${environment.api}/roles/${id}`;
    return this.http.delete<void>(uri);
  }
}
